const AXIOS_STATUS_RE = /^Request failed with status code \d+$/i;
const NETWORK_ERROR_RE = /^Network Error$/i;

/**
 * Pull a human-readable message from send_request / axios failures.
 * Never returns axios status-code boilerplate when the body has detail.
 */
export function extractApiErrorMessage(source, fallback) {
  const data = source?.response?.data ?? source?.data;

  if (typeof data === "string" && data.trim()) {
    return data.trim();
  }

  if (data && typeof data === "object") {
    if (typeof data.detail === "string" && data.detail.trim()) {
      return data.detail.trim();
    }
    if (typeof data.error === "string" && data.error.trim()) {
      return data.error.trim();
    }
    if (typeof data.message === "string" && data.message.trim()) {
      return data.message.trim();
    }
  }

  const raw = typeof source?.message === "string" ? source.message.trim() : "";
  if (raw && !AXIOS_STATUS_RE.test(raw) && !NETWORK_ERROR_RE.test(raw)) {
    return raw;
  }

  return fallback;
}

export function isFailedRequest(response) {
  if (!response) return true;
  if (response instanceof Error) return true;
  if (response.isAxiosError) return true;
  if (response.response) return true;
  return false;
}
